import lightImg from 'assets/img/spot-illustrations/1.png';
import darkImg from 'assets/img/spot-illustrations/dark_1.png';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import { useDispatch } from 'react-redux';
import { signOut } from '../../../redux/slices/authThunk';

const SignOutForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  // localStorage.removeItem('user')
  // localStorage.removeItem('token')
  const dispatch = useDispatch();
  dispatch(signOut())

  return (
    <div className="text-center mb-6 mx-auto">
      {/* <img className="mb-7 d-dark-none" src={lightImg} alt="phoenix" />
      <img className="mb-7 d-light-none" src={darkImg} alt="phoenix" /> */}
      <div className="mb-6">
        <h4 className="text-1000">Logged off</h4>
        <p className="text-700">
          Thanks for using {' '}
          <a href={process.env.PUBLIC_URL} target="_blank" rel="noreferrer">{process.env.COMPANY_NAME}</a>&copy;{' '} {process.env.REACT_APP_NAME}. <br className="d-lg-none" />
          <span className="d-none d-sm-inline-block" />
          <br />
          <br />
          You are now successfully signed out.
        </p>
      </div>
      <div className="d-grid">
        <Button
          variant="primary"
          as={Link}
          to={`/login`}
          startIcon={<FontAwesomeIcon icon={faAngleLeft} className="me-2" />}
        >
          Go to sign in page
        </Button>
      </div>
    </div>
  );
};

export default SignOutForm;